import React from "react";

export const CloseCircle = (props) => {
  return (
    <>
      <svg
        onClick={props?.onClick}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99935 18.3332C14.5827 18.3332 18.3327 14.5832 18.3327 9.99984C18.3327 5.4165 14.5827 1.6665 9.99935 1.6665C5.41602 1.6665 1.66602 5.4165 1.66602 9.99984C1.66602 14.5832 5.41602 18.3332 9.99935 18.3332Z"
          stroke="#383838"
          style={{
            stroke: "#383838",
            stroke: "color(display-p3 0.2196 0.2196 0.2196)",
            strokeOpacity: 1,
          }}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.64258 12.3583L12.3592 7.6416"
          stroke="#383838"
          style={{
            stroke: "#383838",
            stroke: "color(display-p3 0.2196 0.2196 0.2196)",
            strokeOpacity: 1,
          }}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3592 12.3583L7.64258 7.6416"
          stroke="#383838"
          style={{
            stroke: "#383838",
            stroke: "color(display-p3 0.2196 0.2196 0.2196)",
            strokeOpacity: 1,
          }}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
